import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link/Link';
import s from './ThumbCard.scss';

class ThumbCard extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentDidMount() {}

  componentWillUnmount() {}
  handleClick = index => {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick(index);
    }
  };
  render() {
    const { data, index } = this.props;

    if (typeof data === 'undefined') {
      return null;
    }
    if (typeof data.last !== 'undefined' && data.last === 'yes') {
      return (
        <li
          className={data.selected && data.selected === 'yes' ? 'active' : ''}
        >
          <Link to={data.wu} data-newga={`Click-Photostory-0#${data.wu}`}>
            <div className={s.imgwrap}>
              <div className={s.content}>
                <img
                  alt={data.hl}
                  width="100"
                  src={`https://static.toiimg.com/thumb/imgsize-${
                    data.imagesize ? data.imagesize : 1234
                  },msid-${data.imageid},width-100,height-55/${
                    data.imageid
                  }.jpg`}
                />
              </div>
            </div>
          </Link>
        </li>
      );
    }

    return (
      <li
        onClick={() => this.handleClick(index)}
        className={data.selected && data.selected === 'yes' ? 'active' : ''}
      >
        <div className={s.imgwrap}>
          <div className={s.content}>
            <img
              alt={data.hl}
              width="100"
              src={`https://static.toiimg.com/thumb/imgsize-${
                data.imagesize ? data.imagesize : 1234
              },msid-${data.imageid},width-100,height-55/${data.imageid}.jpg`}
            />
          </div>
        </div>
      </li>
    );
  }
}

ThumbCard.propTypes = {
  data: PropTypes.shape({}),
  onClick: PropTypes.func,
};
ThumbCard.defaultProps = {
  data: {},
  onClick: undefined,
};

export default ThumbCard;
